export const toPascalCase = (str: string) => {
    if (!str) {
        return str;
    }
    return str?.length > 0
        ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
        : str;
};
